var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 80,
    viewBox: "0 0 90 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Ativo 1 1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1035_20047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "artwork"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.678316 65.9638H27.4492V78.6797H17.8646C14.3221 78.6797 10.9365 77.3803 8.31778 75.0755C7.71377 74.5431 0.678316 65.9638 0.678316 65.9638Z",
    fill: "url(#paint0_linear_1035_20047)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.678316 65.9638H27.4492V78.6797H17.8646C14.3221 78.6797 10.9365 77.3803 8.31778 75.0755C7.71377 74.5431 0.678316 65.9638 0.678316 65.9638Z",
    fill: "black"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M46.8252 79.4121H89.1016V0.732597L25.8162 63.9146C20.3623 69.3844 12.9096 78.2458 8.10537 73.6482C7.89675 73.4496 2.47462 66.6962 2.47462 66.6962H-0.00100708C-0.00100708 66.6962 6.91524 75.1324 7.44772 75.6192C10.0922 78.0412 13.5672 79.4121 17.2052 79.4121H46.8232H46.8252Z",
    fill: "url(#paint1_linear_1035_20047)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.680664 65.9637H3.15629C3.15629 65.9637 8.57643 72.717 8.78505 72.9157C13.4482 77.3484 21.044 68.6519 26.4959 63.1821L89.7773 0.00206757H89.7812V3.47707L21.1652 72.0177C16.8696 76.3093 10.8037 77.9623 7.83137 74.6065C6.98894 73.6568 0.67868 65.9637 0.67868 65.9637H0.680664Z",
    fill: "url(#paint2_linear_1035_20047)"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NOVO"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.4745 59.9555L52.463 58.0719L58.4025 64.3418L56.7007 65.9539L51.6883 65.0939L54.4883 68.0497L52.4999 69.9334L46.5603 63.6635L48.3249 61.992L53.1643 62.7949L50.4745 59.9555Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8497 60.4688C60.7 62.5053 58.0111 62.5372 56.1274 60.5488C54.2437 58.5603 54.4211 55.8771 56.5708 53.8407C58.7205 51.8042 61.4094 51.7723 63.293 53.7607C65.1767 55.7492 64.9994 58.4324 62.8497 60.4688ZM61.0339 58.552C61.849 57.7799 61.8693 56.707 61.0717 55.865C60.2741 55.0231 59.2017 54.9853 58.3866 55.7575C57.5715 56.5296 57.5512 57.6025 58.3488 58.4445C59.1464 59.2864 60.2188 59.3242 61.0339 58.552Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5382 46.633L66.9835 44.3165L70.4508 52.9283L68.543 54.7356L60.1313 50.8076L62.5766 48.4912L66.7094 50.8983L64.5382 46.633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4864 47.5507C74.3367 49.5871 71.6478 49.6191 69.7641 47.6306C67.8805 45.6422 68.0578 42.9589 70.2075 40.9225C72.3572 38.8861 75.0461 38.8541 76.9298 40.8426C78.8134 42.831 78.6361 45.5143 76.4864 47.5507ZM74.6706 45.6339C75.4857 44.8617 75.506 43.7888 74.7084 42.9469C73.9108 42.1049 72.8384 42.0672 72.0233 42.8393C71.2082 43.6114 71.1879 44.6844 71.9855 45.5263C72.7831 46.3683 73.8555 46.406 74.6706 45.6339Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1035_20047",
    x1: 17.6977,
    y1: 78.94,
    x2: 6.93294,
    y2: 40.5082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#017FA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#0889B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#1A99D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2CBFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#128DC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#017FA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2CBFED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1035_20047",
    x1: 130.929,
    y1: 15.7473,
    x2: -4.47739,
    y2: 94.4963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0193A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#0889B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#1A8ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2CBFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#1298C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7599,
    stopColor: "#036EAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#016BA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2CB3ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1035_20047",
    x1: 100.228,
    y1: -5.87903,
    x2: -60.6,
    y2: 129.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#017FA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#0889B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#1ABAD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2C90ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#1298C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#016BA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2CA8ED"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1035_20047"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.7812 65.4121C89.7812 73.1441 83.5132 79.4121 75.7813 79.4121H0.0011673V-0.000556946H89.7812V65.4121Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNew);
export default __webpack_public_path__ + "static/media/icon-new.778ab4b2d49d1544da44bdfa1c64bb92.svg";
export { ForwardRef as ReactComponent };